export enum COOKIES {
	ACCESS_TOKEN = 'ACCESS_TOKEN',
	TARGET_URL = 'TARGET_URL',
}
